<template>
    <div class="course-list" :class="{ 'hot-course-list': sortKey === 'hot' }">
        <div class="title">
            <span class="main-title" v-if="$i18n.locale === 'en-US'">{{ capitalizedText }}</span>
            <span class="sub-title">{{ $t(`cdutcm.${sortKey}`) }}</span>
        </div>
        <div class="courses">
            <div class="course-card">
                <PlanCard
                    v-for="item in planList"
                    :plan-item="item"
                    :org-config="orgConfig"
                    :key="item.id"
                    @click="$router.push('/plan/' + item.id)"
                />
            </div>
        </div>
        <div class="button-area">
            <div class="plan-cards-more" @click="$router.push(`/tcm/search?sort=${sortKey}`)">
                {{ $t(`cdutcm.more`) }}
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import { plans } from "@/api/home";
import _ from "lodash";
import { datetimeFormat, moneyFormat } from "@/utils/lang";
import PlanCard from "@/views/home/PlanCard.vue";
import { createNamespacedHelpers } from "vuex";
const { mapGetters, mapActions } = createNamespacedHelpers("config");

export default Vue.extend({
    name: "PlanCards",
    components: { PlanCard },
    props: {
        sortKey: {
            type: String,
            default: "new"
        }
    },
    data() {
        return {
            planList: []
        };
    },
    computed: {
        ...mapGetters(["orgConfig"]),
        capitalizedText() {
            return this.sortKey.charAt(0).toUpperCase() + this.sortKey.slice(1);
        }
    },
    methods: {
        mapperPlanList(respData) {
            return _.map(respData, data => {
                let coverPath = "";
                if (data.introduction.cover) {
                    coverPath = data.introduction.cover.thumbnailUrl;
                }
                const setting = data.setting;
                const occupationInfo = data.program.occupationInfo;
                return {
                    id: data.id,
                    planName: data.planName,
                    registrationCount: data.registrationCount,
                    levelName: this.$t("common.levelEnum." + occupationInfo.occupationLevel),
                    level: occupationInfo.occupationLevel,
                    occupationName: occupationInfo.occupationName,
                    classificationName: occupationInfo.classificationName,
                    timeRange:
                        datetimeFormat(setting.startTime, this.$constants.DATE_FMT) +
                        " - " +
                        datetimeFormat(setting.endTime, this.$constants.DATE_FMT),
                    registrationAmount: moneyFormat(setting.fee),
                    registrationEnrollmentCount: data.registrationCount + "/" + setting.enrollmentCount,
                    registrationStatus: setting.registrationStatus,
                    certificateType: setting.certificateType,
                    coverPath: coverPath || require("@/assets/plan-default-cover.png"),
                    orgName: data.org.name
                };
            });
        },
        ...mapActions(["getOrgConfig"])
    },
    async created() {
        await this.getOrgConfig();
        const p = { sortKey: this.sortKey };
        plans(p).then(resp => {
            if (resp.data) {
                this.planList = _.concat(this.planList, this.mapperPlanList(resp.data.data));
                this.planList = this.planList.slice(0, 4);
            }
        });
    }
});
</script>

<style scoped lang="less">
.course-list {
    padding-top: 16px;
    padding-bottom: 16px;
    border-radius: 0 20px 0 20px;
    width: 100%;
    background: #fff;
    &.hot-course-list {
        background: #f2f2f2;
        /deep/ .plan-card-container {
            background: #f2f2f2;
            border-bottom: 1px solid #dcdee2;
        }
    }
    .courses {
        .course-card {
            /deep/.plan-card-container:last-child {
                border-bottom: none;
            }
        }
    }
    .title {
        padding: 8px 20px;
        .main-title {
            color: #c47a0a;
            font-size: 18px;
            font-style: normal;
            font-weight: 900;
            line-height: 130%;
            margin-right: 4px;
        }
        .sub-title {
            color: #0f5394;
            font-size: 18px;
            font-style: normal;
            font-weight: 900;
            line-height: 130%;
        }
    }
    .button-area {
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 8px;
        margin-bottom: 8px;
        .plan-cards-more {
            height: 22px;
            display: flex;
            padding: 6px 4px;
            justify-content: center;
            align-items: center;
            gap: 10px;
            width: 88px;
            border-radius: 8px 0 8px 8px;
            background: #c47a0a;
            cursor: pointer;
            color: #fff;
            font-size: 14px;
            font-style: normal;
            font-weight: 900;
            line-height: 21px;
        }
    }
}
</style>
